import { FormatColorResetOutlined, WaterDrop } from '@mui/icons-material'
import { useTheme } from '@mui/material'

import { UnknownBubble } from '../data-icons'

const LeakBubble = ({ value, isOffline }: { value: number; isOffline: boolean }) => {
  const theme = useTheme()

  const offlineText = isOffline ? ' (Offline)' : ''

  const { ariaLabel, iconColor, IconComponent } = {
    0: { ariaLabel: 'No water', iconColor: theme.palette.text.disabled, IconComponent: FormatColorResetOutlined },
    1: { ariaLabel: 'Water detected', iconColor: theme.palette.info.main, IconComponent: WaterDrop },
  }[value] ?? { ariaLabel: 'Unknown', iconColor: theme.palette.text.primary, IconComponent: UnknownBubble }

  return <IconComponent htmlColor={isOffline ? theme.palette.divider : iconColor} aria-label={`${ariaLabel}${offlineText}`} />
}

export default LeakBubble
